<template>
  <div class="h5-search-list">
    <div
      class="h5-search-item"
      v-for="item of list"
      :key="item.en"
      @click="onSearchItemClick(item)"
    >
      <Image
        :src="item.product_list[0].image_url"
        class="h5-search-item__image"
      />
      <template
        v-for="product of item.product_list.slice(1, 5)"
        :key="product.offerId"
      >
        <Image
          :src="product.image_url"
          class="h5-search-item__thumbnail"
        />
      </template>
      <div class="h5-search-item__more">
        More
      </div>
      <div class="h5-search-item__title">
        <img
          src="@/assets/colorIcon/ai-search.svg"
          class="h5-search-item__search"
        >
        <span>{{ item.en }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Image } from '@/components/Image'
import { openURLWithChannelQuery } from '@/utils/utils'

defineProps({
  list: {
    type: Array,
    default: () => []
  }
})

const onSearchItemClick = (item) => {
  openURLWithChannelQuery(`/search?keyword=${item.en}&keywordCn=${item.cn}&isAISearched=true`)
}
</script>

<style lang="less" scoped>
.h5-search-list {
  display: flex;
  gap: 8px;
  margin: 0 -16px;
  padding: 0 16px;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
}

.h5-search-item {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  padding: 4px;
  border-radius: 8px;
  border: 1px solid #EBF1F5;
  cursor: pointer;

  &__image {
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    width: 110px;
    height: 110px;
    border-radius: 4px;
  }

  &__thumbnail {
    width: 53px;
    height: 53px;
    border-radius: 4px;
  }

  &__more {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F8F8F8;
    font-family: mon-500;
    font-size: 12px;
    border-radius: 4px;
  }

  &__title {
    grid-column: 1 / 4;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 12px 4px;
    font-family: mon-600;
    font-size: 14px;

    > span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
